import { render } from "./BaseProgressMetric.vue?vue&type=template&id=d49f3f38"
import script from "./BaseProgressMetric.vue?vue&type=script&lang=js"
export * from "./BaseProgressMetric.vue?vue&type=script&lang=js"

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BaseProgressMetric.vue"]])

export default __exports__